import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const PanJamonDialog = ({
  panJamonDialog,
  setPanJamonDialog,
  panJamonOption,
  setPanJamonOption,
  panaderia,
  cart,
  setCart
}) => {
  return (
    <Dialog open={panJamonDialog} onOpenChange={setPanJamonDialog}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-chocolate flex items-center gap-2">
            🥖 Pan de Jamón
          </DialogTitle>
          <DialogDescription>
            Tradicional pan navideño relleno de jamón, pasas y aceitunas. ~45 cm.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <Label className="text-base font-semibold">Selecciona tu opción:</Label>
          <RadioGroup 
            value={panJamonOption} 
            onValueChange={setPanJamonOption}
            className="space-y-3"
          >
            {panaderia[0]?.options?.map(option => (
              <div 
                key={option.id} 
                className={`flex items-center space-x-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${
                  panJamonOption === option.id 
                    ? 'border-[#4a2c2a] bg-[#4a2c2a]/5 shadow-md' 
                    : 'border-gray-200 hover:border-caramel'
                }`}
                onClick={() => setPanJamonOption(option.id)}
              >
                <RadioGroupItem value={option.id} id={`pj-${option.id}`} className="flex-shrink-0" />
                <Label htmlFor={`pj-${option.id}`} className="flex-grow cursor-pointer">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-chocolate">{option.name}</span>
                    <span className="text-xl font-bold text-caramel">
                      ${(panaderia[0].price + option.extraPrice).toFixed(2)}
                    </span>
                  </div>
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        <DialogFooter>
          <Button
            onClick={() => {
              const selectedOption = panaderia[0].options.find(o => o.id === panJamonOption);
              const cartItem = {
                type: 'Panadería',
                name: panaderia[0].name,
                size: selectedOption?.name || 'Tradicional',
                price: panaderia[0].price + (selectedOption?.extraPrice || 0),
                quantity: 1
              };
              setCart([...cart, cartItem]);
              setPanJamonDialog(false);
            }}
            className="w-full bg-caramel hover:bg-amber-600 text-white py-6 text-lg"
          >
            🥖 Agregar al Pedido - ${(panaderia[0]?.price + (panaderia[0]?.options?.find(o => o.id === panJamonOption)?.extraPrice || 0)).toFixed(2)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PanJamonDialog;
